export default __webpack_public_path__ + "static/media/videoIcon.0e253447.svg";